export type TranscriptLanguage = 'en' | 'ar' | 'fr' | 'es'

export const transcriptLanguages: {
  code: TranscriptLanguage
  name: string
  nativeName: string
  rtl?: boolean
}[] = [
  { code: 'en', name: 'English', nativeName: 'English' },
  { code: 'ar', name: 'Arabic', nativeName: 'العربية', rtl: true },
  { code: 'fr', name: 'French', nativeName: 'Français' },
  { code: 'es', name: 'Spanish', nativeName: 'Español' },
]
